import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { styled } from '@mui/material/styles';
import { IDocumentUnscopedExtraction, IDocumentUnscoped } from '../../types/my-types';
import CollapsedTitleWithTooltip from '../common/CollapsedTitleWithTooltip';
import { LinkTableStyled } from '../common/StyledComponents';

interface Props {
  dataPoolId: string;
  extractions: IDocumentUnscopedExtraction[];
  document: IDocumentUnscoped;
}

const UlExtractions = styled('ul')({
  textAlign: 'left',
  margin: 0,
  padding: 0,
});

const LiExtractionItem = styled('li')({
  listStyleType: 'none',
});

const CheckCircleIconStyled = styled(CheckCircleIcon)(({ theme }) => ({
  color: theme.palette.custom.lightGreen,
  maxWidth: '15px',
  paddingLeft: '5px',
  verticalAlign: 'middle',
}));

function ExtractionList({ dataPoolId, extractions, document }: Props) {
  if (!extractions || extractions.length === 0) return null;

  return (
    <UlExtractions data-cy={`ul-document-extraction-list-${document.id}`}>
      {extractions.map((extraction: any, index: number) => (
        <LiExtractionItem key={index}>
          {extraction.extraction_batch ? (
            <>
              <LinkTableStyled
                to={`/data-pools/${dataPoolId}/extraction-batch/${extraction.extraction_batch}/details`}
                data-cy={`link-extraction-batch-details-${extraction.extraction_batch_label}`}
              >
                <CollapsedTitleWithTooltip title={extraction.extraction_batch_label || 'Deleted'} />
              </LinkTableStyled>
              {extraction.verified && <CheckCircleIconStyled />}
            </>
          ) : (
            <span>{extraction.extraction_batch_label || 'Deleted'}</span>
          )}
        </LiExtractionItem>
      ))}
    </UlExtractions>
  );
}

export default ExtractionList;
